<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  SERVICE_ACTIONS,
  CREATE_SERVICE_ACTIONS,
  UPDATE_SERVICE_ACTIONS,
  DELETE_SERVICE_ACTIONS,
} from '@/services/api/setting/maintenance/setting/serviceActions'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'action',
          label: this.$t('maintenance.field.activity'),
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          isEditable: true,
          validation: [['required'], ['isUnique', this.data]],
          orderBy: 'asc',
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: SERVICE_ACTIONS,
            variables: {
              filter: filter,
            },
          })
          let self = this
          self.data = res.data.serviceActions.serviceActions.data
          const result = res.data.serviceActions.serviceActions
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            }
          })
          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: CREATE_SERVICE_ACTIONS,
            variables: {
              input: {
                action: data.action,
              },
            },
          })

          return res.data.createServiceAction.createServiceAction
        },
        update: async (id, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: UPDATE_SERVICE_ACTIONS,
            variables: {
              input: {
                oldData: {
                  action: oldData.action,
                },
                newData: {
                  action: newData.action,
                },
                serviceActionId: Number(id),
              },
            },
          })

          if (!res.data.updateServiceAction.isSuccessful) {
            this.$mcToast.error({
              component: 'McToastDynamicBody',
              props: {
                contents: [
                  {
                    tag: 'h6',
                    text: this.$t('maintenance.alert.editFailed'),
                  },
                  {
                    tag: 'p',
                    text: this.$t(`global.alert.text.failedEdit`),
                  },
                ],
              },
            })
            return false
          }
          return res.data.updateServiceAction.updateServiceAction
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_ACTIONS,
            variables: {
              input: {
                serviceActionId: Number(id),
              },
            },
          })
          return res.data.deleteServiceAction.isSuccessful
        },
      }
    },
    buttons() {
      return [
        {
          variant: 'secondary',
          class: 'me-2',
          id: 'cat-service-log-button',
          text: this.$t('global.historyUpdate'),
          icon: 'icon-outline_file-text',
          handleClick: () => {
            this.handleClick()
          },
        },
      ]
    },
  },

  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },

  methods: {
    handleClick() {
      this.$router.push({ name: 'Log Maintenance Setting', params: { type: 'actions' } })
    },

    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t(`maintenance.errorMessages.CompServiceDelete`),
            },
          ],
        },
      })
    },
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0 pb-4" @click="$store.commit('setting/SET_STATUS', status)">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('maintenance.field.activity') }}</span>
    </template>

    <!-- Table -->
    <McGraphqlEditableTable
      :fields="fields"
      :buttons="buttons"
      :apiClient="query"
      :searchable="true"
      trackBy="serviceActionId"
      :isPredefined="true"
      :customToast="customToast"
    />
  </b-tab>
</template>
